import '@/css/components/core/MyButton.css'

interface MyButtonProps {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
}

export function MyButton({
    label,
    onClick,
    disabled = false,
}: MyButtonProps) {
    return (
        <button
            className="my-button"
            onClick={onClick}
            disabled={disabled}
        >
            <p
                style={
                    {
                        whiteSpace: 'nowrap',
                    }
                }
            >{label}</p>
        </button>
    );
}
